import { useState, useEffect } from 'react';

export default (time = 0, step = 1, timeout = 1000) => {
  const [timer, setTimer] = useState(time);

  const restart = () => setTimer(time);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(current => {
        if (current <= 0) {
          clearInterval(interval);
          return 0;
        }

        return current - step;
      });
    }, timeout);

    return () => clearInterval(interval);
  }, [timer]);

  return [timer, timer > 0, restart];
};
